<template>
  <div class="ParkCompleteSet">
    <!-- <Navigator :title="serviceMsg.serviceName" :routePath='"/"'></Navigator>
    <Tabbar @changeActive='changeActive' :serviceId="serviceMsg.serviceId" :outActive='active'></Tabbar> -->

    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Navigator from '@/components/Navigator';
import Tabbar from '@/components/Tabbar';

export default {
  data() {
    return {
      active: 0,
      listInfo:[],
      serviceMsg: {},
    };
  },
  methods: {
    changeActive(typeId) {
      this.active = typeId;
      if (typeId === 13) {
        this.$router.push({path: '/parkCompleteSet/campusActivities', query: this.$route.query});
      } else if (typeId === 14) {
        this.$router.push({path: '/parkCompleteSet/exclusiveActivities', query: this.$route.query});
      } else {
        this.$router.push({path: '/parkCompleteSet/foodCourt', query: this.$route.query});
      }
    },
  },
  computed: {
    ...mapGetters(['parkServiceList']),
  },
  components: {Tabbar},
  created() {
    this.serviceMsg = this.parkServiceList.find((val) => {
      return val.serviceFlag === 6;
    });
    const path = this.$route.path.split('/')[2];
    if (path === 'campusActivities') {
      this.active = 13;
    } else if (path === 'exclusiveActivities') {
      this.active = 14;
    } else if (path === 'foodCourt') {
      this.active = 9;
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@scss';
.ParkCompleteSet{
  background: rgb(245, 245, 245);
}
.van-tabbar{
  position: relative;
  height: 2.986667rem;
  padding: .533333rem .533333rem 0 .533333rem;
  box-sizing: border-box;
  overflow-x: auto;
  overflow-y: hidden;
  .van-tabbar-item{
    .van-tabbar-item__icon .icon_wrap{
      width: 1.333333rem;
      height: 1.333333rem;
      text-align: center;
      line-height: 1.333333rem;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .van-tabbar-item__text .text_wrap{
      text-align: center;
      .text{
        line-height: .88rem;
        font-size: .32rem;
        color: rgb(51, 51, 51);
        font-weight: 600;
      }
      .active_icon{
        display: inline-block;
        border-bottom: .266667rem solid rgb(245, 245, 245);
        border-left: .266667rem solid transparent;
        border-right: .266667rem solid transparent;
      }
      .hidden_icon{
        display: inline-block;
        height: .266667rem;
      }
    }
  }
}
.van-hairline--top-bottom::after {
    border-width: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/parkCompleteSet/ParkCompleteSet.vue